import { render, staticRenderFns } from "./ServeCommitment.vue?vue&type=template&id=238e8784&scoped=true&"
import script from "./ServeCommitment.vue?vue&type=script&lang=js&"
export * from "./ServeCommitment.vue?vue&type=script&lang=js&"
import style0 from "./ServeCommitment.vue?vue&type=style&index=0&id=238e8784&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e8784",
  null
  
)

export default component.exports